import { useTranslations } from 'next-intl';
import Link from 'next/link';
import type { FooterNavigationLinksSectionConfig } from '../../../../config/footer.types.ts';
import { NavigationLinkList } from '../NavigationLinkList/NavigationLinkList';

type NavigationLinksSectionProps = {
  config: FooterNavigationLinksSectionConfig;
};

function NavigationLinksSection({ config }: NavigationLinksSectionProps) {
  const t = useTranslations('footer.navigation_links');
  const { groups } = config;
  const columnCount = groups.length;

  return (
    <div className={`grid grid-cols-2 md:grid-cols-${columnCount ?? 4} gap-6 mt-6 mb-6`} data-track-container="Links">
      {groups.map(group => (
        <NavigationLinkList key={group.titleKey} title={t(group.titleKey)} data-track-container={group.trackName}>
          {group.links.map((link, index) => {
            return (
              <Link key={index} href={link.href} prefetch={false} target={link.target} rel={link.rel} data-track-name={link.trackName}>
                {t(link.labelKey)}
              </Link>
            );
          })}
        </NavigationLinkList>
      ))}
    </div>
  );
}

export { NavigationLinksSection };
